const HMCOMP = () => import('./../views/Compras.vue')
const CONTR = () => import('./../views/Contratos.vue')
const PROC = () => import('./../views/Processos.vue')
const FORNEC = () => import('./../views/Fornecedor.vue')

export default [
  { name: 'viewCompras', path: '/compras', component: HMCOMP, meta: { acl: true } },
  { name: 'viewContratos', path: '/compras/contratos', component: CONTR, meta: { acl: true } },
  { name: 'viewProcCompras', path: '/compras/processo-de-compra', component: PROC, meta: { acl: true } },
  { name: 'viewFornecedores', path: '/compras/fornecedores', component: FORNEC, meta: { acl: true } }
]
